import _ from 'lodash'
import router from '@/router/index.js'
import { mapFormFieldsJSON } from '@/store/helpers/formHelper.js'

export default {
  SET_MY_APPLICATIONS (state, applications) {
    state.myApplications = applications
  },
  SET_NEW_APPLICATION (state, application) {
    state.myApplications.unshift(application)
  },
  SET_APPLICATION_PROPERTY_ID (state, propertyId) {
    state.createApplication.propertyId = propertyId
  },
  SET_APPLICATION_PROPERTY_TYPES (state, applicationTypes) {
    state.applicationPropertyTypes = applicationTypes
  },
  SET_APPLICATION_ADVANCED_TYPES (state, applicationTypes) {
    state.applicationAdvancedTypes = applicationTypes
  },
  SET_APPLICATION_PROPERTY_TYPE (state, applicationType) {
    state.createApplication.applicationPropertyType = applicationType
  },
  SET_APPLICATION_ADVANCED_TYPE (state, applicationType) {
    state.createApplication.applicationAdvancedType = applicationType
  },
  SET_APPLICATION_COMMUNITY (state, community) {
    state.createApplication.propertyCommunityId = community
  },
  SET_APPLICATION_COMMUNITY_ADVANCED (state, community) {
    state.createApplication.advancedCommunityId = community
  },
  SET_APPLICATION_PERSON_ID (state, personId) {
    state.createApplication.formData.personId = personId
  },
  SET_APPLICATION_PERSON_CONTACT_ID (state, personId) {
    state.createApplication.formData.personContactId = personId
  },
  SET_APPLICATION_FORM_FIELDS (state, applicationJSON) {
    const { personId, personContactId } = state.createApplication.formData
    const newState = mapFormFieldsJSON(applicationJSON)
    newState.personId = personId
    newState.personContactId = personContactId
    state.initalCreateApplication.formData = _.cloneDeep(newState)
    state.createApplication.formData = newState
  },
  SET_FORMFIELD_VALUE (state, { tab, field, value }) {
    state.createApplication.formData[tab][field] = value
  },
  SET_UPDATE_FORMFIELD_JSON (state, json) {
    state.updateApplication.json = json
  },
  UPDATE_FORMFIELD_VALUE (state) {
    const json = state.updateApplication.json

    Object.keys(json).map(key => {
      const tab = json[key]
      if (Array.isArray(tab)) {
        tab.forEach(fieldElement => {
          const { name: field, value } = fieldElement
          state.createApplication.formData[key][field] = value
        })
      }
    })
  },
  SET_APPLICATION_FORM_DIRTY (state) {
    const isEqual = _.isEqual(state.initalCreateApplication.formData, state.createApplication.formData)
    state.isFormDirty = !isEqual
  },
  SET_APPLICATION_PROPERTY_FINAL (state) {
    state.createApplication.finalCommunityId = state.createApplication.propertyCommunityId
    state.createApplication.finalApplicationType = state.createApplication.applicationPropertyType
    state.createApplication.applicationAdvancedType = null
    state.createApplication.advancedCommunityId = null
  },
  SET_APPLICATION_ADVANCED_FINAL (state) {
    state.createApplication.finalCommunityId = state.createApplication.advancedCommunityId
    state.createApplication.finalApplicationType = state.createApplication.applicationAdvancedType

    state.createApplication.applicationPropertyType = null
    state.createApplication.propertyId = null
    state.createApplication.propertyCommunityId = null
    state.createApplication.formData.personId = -1
  },
  RESET_APPLICATION_FORM (state) {
    state.createApplication.propertyId = null
    state.createApplication.propertyCommunityId = null
    state.createApplication.advancedCommunityId = null
    state.createApplication.finalCommunityId = null
    state.createApplication.applicationPropertyType = null
    state.createApplication.applicationAdvancedType = null
    state.createApplication.finalApplicationType = null
    state.createApplication.applictionTypeName = ''
    state.createApplication.isFormDirty = false
    state.createApplication.correspondence = null
    state.initalCreateApplication.formData = {
      eigentuemer: {},
      kontaktPerson: {},
      objekt: {},
      gesuch: {},
      personId: -1,
      personContactId: -1
    }
    state.createApplication.formData = {
      eigentuemer: {},
      kontaktPerson: {},
      objekt: {},
      gesuch: {},
      personId: -1,
      personContactId: -1
    }
  },
  SET_MODAL_SHOW (state, { boolShow, modalMethod, tabName, draftId }) {
    state.modalShow = boolShow
    state.modalMethod = modalMethod
    router
      .push({
        name: 'uebersicht',
        params: {
          modalMethod,
          draftId,
          tabName
        }
      })
      .catch(() => {})
  },
  SET_APPLICATION_TYPE_NAME (state, name) {
    state.createApplication.applictionTypeName = name
  },
  SET_MODAL_PAGE (state, page) {
    state.modalPage = page
  },
  SET_PROPERTY_MODAL_VISIBLE (state, { boolShow }) {
    state.isPropertyModalVisible = boolShow
  },
  SET_PERSON_MODAL_VISIBLE (state, { boolShow }) {
    state.isPersonModalVisible = boolShow
  },
  SET_CORRESPONDENCE (state, value) {
    state.createApplication.correspondence = value
  },
  SET_PAGE_INDEX (state, value) {
    state.pageIndex = value
  }
}
